const populateHeader = require('./populate-header');
const populateAccessToken = require('./populate-access-token');
const populateEntity = require('./populate-entity');

let hooks = {
  populateHeader,
  populateAccessToken,
  populateEntity
};

module.exports = hooks;



//////////////////
// WEBPACK FOOTER
// ./~/@feathersjs/authentication-client/lib/hooks/index.js
// module id = 198
// module chunks = 0